<template lang="pug">
  b-modal#settings(
    ref="settings"
    :title="$t('ui.combine.edit_settings')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="sm"
    hide-footer
    @show="reset"
    @shown="shown"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      .form-group
        label {{ $t("ui.account_id") }}
        DebounceInput(
          type="text"
          ref="account_id"
          :placeholder='$t("ui.account_id")'
          :value="accountId.toUpperCase()"
          readonly
        )
      .form-group
        table.table.table-sm.table-bordered(v-if="platformList")
          tr
            th.bg-grey.w-50 {{ $t('ui.platform') }}
            th.bg-grey {{ $t('ui.status') }}
          tr(v-for="x in platformList")
            td.align-middle {{ $t('ui.provider_' + x.platform_name.toLowerCase()) }}
            td.align-center
              label.switch.switch-label.switch-success(style="margin: 5px 0 0 0;")
                input(type="checkbox" class="switch-input" v-model="x.enable_platform" @change="submit(x, $event)")
                span(class="switch-slider" :data-checked="$t('ui.on')" :data-unchecked="$t('ui.off')")
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
</template>

<script>
import config from "@/config"
import SubmitButton from "@/library/SubmitButton"
import DebounceInput from "@/library/DebounceInput"

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  props: {
    accountId: ""
  },
  data() {
    return {
      platformList: [],
      loading: false,
      submission: {
        success: true,
        status: ""
      }
    };
  },
  validations: {},
  methods: {
    getPlatform: function() {
        return;
      let account_id = this.accountId
      this.loading = true
      this.$store
        .dispatch("user/getPlatform", { account_id })
        .then(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = response.status
          if (this.submission.success == true) {
            this.loading = false
            let child = response.data.platform
            let parent = this.$store.getters.getPlatformList
            parent = parent.map(item => {
              let item2 = child.find(i2 => i2.platform_name === item.platform_name)
              if(!item2) {
                item.enable_platform = false
              }
              return item2 ? { ...item, ...item2 } : item
            })
            this.platformList = parent
          }
        })
        .catch(response => {
          console.log("Failed:settings", response)
          this.loading = false
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    submit: function(mode, event) {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_platform_settings_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updatePlatform(mode, event)
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_platform_settings_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    updatePlatform: function(mode, event) {
      let account_id = this.accountId
      let platform_code = mode.platform_code
      let platform_name = mode.platform_name
      let status = (event.srcElement.checked) ? 1 : 0
      this.loading = true
      this.$store
        .dispatch("user/updatePlatform", { account_id, platform_code, platform_name, status })
        .then(response => {
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = response.status;
          if (this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_platform_settings_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          console.log("Failed:settings", response)
          this.loading = false;
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset();
        this.getPlatform()
      });
    },
    cancel: function() {
      // this.$refs.settings.hide()
      this.getPlatform()
    }
  }
};
</script>

